module.exports = __webpack_public_path__ + "static/media/tommySleeve2.9a09743b.svg";